import FrequentlyUsedField from "@/enum/FrequentlyUsedField";
import mainServerClient from "../http/mainServerClient";

export interface OrderSearchPaneSetting {
    companyId: number;

    frequentlyUsedFields: FrequentlyUsedField[];
}

export function getOrderSearchPanelSettingList(): Promise<OrderSearchPaneSetting> {
    return mainServerClient.get("/order_search_pane_setting/get");
}
